import { OTHERWORLD_BACKDROPS } from '../../../game/effects/atmosphere/silhouettes/otherworldBackdrops';
import { sunkenBiome } from '../biomeArchetypes';
import { Z_LAYERS } from '../../../game/rendering/Z_LAYERS';

/** Sunken drift — the sunken cathedral. Vast interior vault with drifting whale
 *  skeletons, cold caustic shimmer, schooling motes between the bones, vault
 *  columns, and a heavy dark grade. Interior opt-out (no day-clock). */
export const SUNKEN_DRIFT = sunkenBiome({
  id: 'sunken_drift',
  sky: { from: 0x05100e, to: 0x0c2a26 },
  motes: { colors: [0x4a9e98, 0x8fbfb8], count: 14, sizeMin: 5, sizeMax: 12, driftPx: 18, periodMinMs: 12000, periodMaxMs: 24000, alphaMin: 0.12, alphaMax: 0.45 },
  glow: {
    blobs: [
      { color: 0x1a4a44, atX: 0.5, atY: 0.6, size: 500, alpha: 0.06 },
      { color: 0x0c2a26, atX: 0.2, atY: 0.3, size: 400, alpha: 0.04 },
    ],
    breathe: { periodMs: 8000, min: 0.7, max: 1.3 },
  },
  lightField: { palette: [0x1a4a44, 0x0c2a26], count: 10, sizeMin: 100, sizeMax: 220, alphaMin: 0.03, alphaMax: 0.12, driftRadius: 50, periodMinMs: 10000, periodMaxMs: 20000 },
  caustics: { color: 0x4a9e98, count: 5, sizeMin: 120, sizeMax: 280, alphaMin: 0.04, alphaMax: 0.12, bandYMin: 0.7, bandYMax: 0.95, driftPx: 30, periodMinMs: 8000, periodMaxMs: 16000 },
  leviathans: {
    shape: 'whaleSkeleton',
    planes: [
      { count: 1, widthMin: 200, widthMax: 400, speedMin: 8, speedMax: 14, alpha: 0.12, tint: 0x8fbfb8, depth: Z_LAYERS.LEVIATHAN_FAR },
      { count: 1, widthMin: 500, widthMax: 800, speedMin: 5, speedMax: 10, alpha: 0.18, tint: 0xbfeae0, depth: Z_LAYERS.LEVIATHAN_NEAR },
    ],
    bob: { ampPx: 12, periodMinMs: 8000, periodMaxMs: 16000 },
    edgeHighlight: true,
    edgeColor: 0xbfeae0,
    detail: 1,
    direction: 'both',
    bandYMin: 0.1,
    bandYMax: 0.45,
  },
  schoolingMotes: { count: 24, schools: 2, palette: [0x4a9e98, 0x8fbfb8], sizeMin: 3, sizeMax: 7, speed: 22, cohesion: 0.3, alignment: 0.4, separation: 0.5, bandYMin: 0.3, bandYMax: 0.7, startle: true },
  parallax: [
    { svg: OTHERWORLD_BACKDROPS.ruins.far, shape: 'columns', color: 0x0a1f1c, speed: 0.03, height: 500, alpha: 0.6, detail: 0.8, sway: { ampPx: 6, periodMs: 40000 } },
    { svg: OTHERWORLD_BACKDROPS.ruins.mid, shape: 'columns', color: 0x081814, speed: 0.08, height: 350, alpha: 0.8, detail: 1.0 },
    { svg: OTHERWORLD_BACKDROPS.ruins.near, shape: 'columns', color: 0x05100e, speed: 0.15, height: 200, alpha: 0.95, detail: 1.0 },
  ],
  fog: { color: 0x05100e, bands: 4, alphaMin: 0.06, alphaMax: 0.16, driftPx: 20, periodMinMs: 12000, periodMaxMs: 24000, yMin: 0.4, yMax: 0.9, sizeMin: 200, sizeMax: 400 },
  closer: { vignette: { color: 0x000000, edgeAlpha: 0.5, washColor: 0x05100e, washAlpha: 0.06 }, grade: { top: 0x05100e, bottom: 0x0c2a26, strength: 0.15, blend: 'normal' } },
});
